var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgHeartIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 12.444,
    height: 11.077,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.221 1.949A4.173 4.173 0 0 1 7.214.74a3.178 3.178 0 0 1 5.164 1.895 2.87 2.87 0 0 1-.025 1.328 6.209 6.209 0 0 1-1.823 2.473c-.394.374-.774.722-1.146 1.069a19.119 19.119 0 0 0-3.157 3.572 19.2 19.2 0 0 0-3.164-3.573L1.918 6.435A6.142 6.142 0 0 1 .092 3.962a2.87 2.87 0 0 1-.029-1.327A3.179 3.179 0 0 1 5.228.738a4.176 4.176 0 0 1 .994 1.209Z",
    fill: "#de5353",
    fillRule: "evenodd"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHeartIcon);
export default __webpack_public_path__ + "static/media/heart-icon.64a5b85177d643cb5788e5e5c66467f8.svg";
export { ForwardRef as ReactComponent };